import { render, staticRenderFns } from "./UserDetailTab.vue?vue&type=template&id=148e33ff&"
import script from "./UserDetailTab.vue?vue&type=script&lang=ts&"
export * from "./UserDetailTab.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailTab.vue?vue&type=style&index=0&id=148e33ff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports